import Component from '../core/Component';
import Flickity from 'flickity-sync';

export default class AdvantagesCarousel extends Component {

    constructor(element) {
        super(element);

        this.ref = {
            content: null,
            dots: [],
            slides: [],
            counter: null,
            slider: null,
        }

        this.handleResize = :: this.handleResize;
    }

    prepare() {
        let isIE = /*@cc_on!@*/false || !!document.documentMode;
        if (!isIE) {
            this.rearange()
        }

        this.flickity = new Flickity(this.ref.content, {
            cellSelector: '.AdvantagesCarousel-Slide',
            prevNextButtons: false,
            wrapAround: true,
            selectedAttraction: 0.1,
            friction: .7,
            pageDots: false,
            resize: true,
            sync: this.ref.slider,
            pauseAutoPlayOnHover: false,
        });

        this.slider = new Flickity(this.ref.slider, {
            cellSelector: '.AdvantagesCarousel-ImageItem',
            prevNextButtons: false,
            wrapAround: true,
            selectedAttraction: 0.1,
            friction: .7,
            pageDots: false,
            resize: true,
            pauseAutoPlayOnHover: false,
            draggable: true,
        });

        this.flickity.on('select', :: this.handleSelect);
        window.addEventListener('load', this.handleResize);

        this.slider.on('staticClick', function (event, pointer, cellElement, cellIndex) {
            this.next();
        });

        $(this.ref.dots).on('click', (event) => {
            this.slider.selectCell(this.ref.slides[this.ref.dots.indexOf(event.target)]);
        });

        this.flickity.stopPlayer();
    }

    shuffle(array) {
        var currentIndex = array.length, temporaryValue, randomIndex;

        // While there remain elements to shuffle...
        while (0 !== currentIndex) {

            // Pick a remaining element...
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex -= 1;

            // And swap it with the current element.
            temporaryValue = array[currentIndex];
            array[currentIndex] = array[randomIndex];
            array[randomIndex] = temporaryValue;
        }

        return array;
    }

    rearange() {
        this.array = [...Array(this.ref.slides.length).keys()]
        this.order = this.array;

        const slides = this.ref.slides;
        for (let i = 0; i < this.ref.slides.length; i++) {
            this.ref.slides[i].outerHTML = "";
        }

        this.ref.slides = [];

        for (let i = 0; i < this.order.length; i++) {
            this.ref.slides.push(slides[this.order[i]]);
        }

        this.textContents = this.ref.content.querySelectorAll('.AdvantagesCarousel-Slide');
        this.ref.content.innerHTML = "";


        for (let i = 0; i < this.order.length; i++) {
            this.ref.slider.appendChild(slides[this.order[i]]);
            this.ref.content.appendChild(this.textContents[this.order[i]]);
        }
    }

    destroy() {
        this.flickity.stopPlayer();
        window.removeEventListener('load', this.handleResize);
    }

    handleResize = () => {
        this.flickity.resize();
        this.slider.resize();
    }

    handleSelect() {
        this.ref.dots.forEach((dot, index) => dot.classList.toggle('is-active', index === this.flickity.selectedIndex));
        this.ref.counter.innerText = `0${this.flickity.selectedIndex + 1}/0${this.flickity.slides.length}`;
    }
}
